import { render } from "./WareHouseRegionSavePage.vue?vue&type=template&id=d37290c8"
import script from "./WareHouseRegionSavePage.vue?vue&type=script&lang=js"
export * from "./WareHouseRegionSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script